"use client";

import { Logo } from "@/components/shared/Logo";
import { MainNav } from "./MainNav";
import { RightNav } from "./RightNav";
import { useNavCollapsed } from "./ScrollableHeader";
import { cn } from "@/lib/utils";
import type { TransformedNavData } from "@/lib/navigation-utils";

interface HeaderInnerProps {
  navData: NonNullable<TransformedNavData>;
}

export function HeaderInner({ navData }: HeaderInnerProps) {
  const collapsed = useNavCollapsed();

  return (
    <div className={cn("w-full px-4 sm:px-6 xl:px-8 transition-all duration-300", collapsed ? "py-1.5" : "py-4")}>
      <div
        className={cn(
          "flex items-center justify-between xl:grid xl:grid-cols-[1fr_auto_1fr] xl:gap-4 transition-all duration-300",
          collapsed ? "h-12" : "h-20"
        )}
      >
        {/* Logo — pinned to the left of its 1fr column */}
        <Logo
          logo={navData.logo}
          logoText={navData.logoText}
          width={360}
          height={90}
          className={cn(
            "translate-y-1 transition-all duration-300 h-auto shrink-0 xl:justify-self-start",
            collapsed ? "w-[160px] xl:w-[200px]" : "w-[160px] xl:w-[360px]"
          )}
        />

        {/* Desktop centered nav — auto-sized center column lands at true center
            because the flanking 1fr columns split remaining space equally */}
        <MainNav items={navData.navItems} />

        {/* Desktop right-side nav (max 2) — pinned to the right of its 1fr column */}
        <RightNav items={navData.rightNavItems} />
      </div>
    </div>
  );
}
